import n from 'vscode/external/rollup-plugin-styles/dist/runtime/inject-css.js';

var css = ".monaco-editor .contentWidgets .empty-editor-hint{color:var(--vscode-input-placeholderForeground)}.monaco-editor .contentWidgets .empty-editor-hint a{color:var(--vscode-textLink-foreground)}";
n(css,{});

export { css, css as default };
